export default class ResultsStates{
	total:number = 0;
	correct:number = 0;
	inCorrect:number = 0;
	
	constructor({total, correct, inCorrect}:{total:number, correct:number, inCorrect:number}={total:0, correct:0, inCorrect:0}){
		this.total = total;
		this.correct = correct;
		this.inCorrect = inCorrect;
	}

	increaseCorrect(){
		this.correct++;
		this.total++;
	}
	increaseInCorrect(){
		this.inCorrect++;
		this.total++;
	}
}